import { Typography } from "@mui/material";
import finance from "financejs";
import { millisToDays, toSpanishDate } from "../../../helpers/dateFormat";
import {
  numberFormat,
  participationsFormat,
} from "../../../helpers/numberFormat";
import { transformDivestments } from "../../../helpers/finance";

// export const columnDivestmentClub = (t) => {
//     return (
//         [
//             {
//                 field: 'startupAlias',
//                 headerName: t('positions.startup'),
//                 minWidth: 180,
//                 flex: 1,
//                 align: 'center',
//                 headerAlign: 'center',
//             },
//             {
//                 field: 'roundNumber',
//                 headerName: t('positions.roundNumber'),
//                 minWidth: 110,
//                 flex: 1,
//                 align: 'center',
//                 headerAlign: 'center'
//             },
//             {
//                 field: 'amount',
//                 headerName: t('positions.amount'),
//                 minWidth: 90,
//                 flex: 1,
//                 align: 'center',
//                 headerAlign: 'center',
//                 valueGetter: ({ row }) => numberFormat(((row.participationValuation * row.divestmentParticipation)).toFixed(2))
//             },
//             {
//                 field: 'participationValuation',
//                 headerName: t('positions.participationValuation'),
//                 minWidth: 140,
//                 flex: 1,
//                 align: 'center',
//                 headerAlign: 'center',
//                 valueGetter: (params) => {
//                     const resp = params.row.participationValuation;
//                     return (isNaN(resp) || resp === null || resp === 'Infinity' ? '-' : numberFormat(resp))
//                 }
//             },
//             {
//                 field: 'shares',
//                 headerName: t('positions.shares'),
//                 minWidth: 120,
//                 flex: 1,
//                 align: 'center',
//                 headerAlign: 'center',
//                 valueGetter: (params) => {
//                     const resp = (params.row.divestmentParticipation).toFixed(2)
//                     return (isNaN(resp) || resp === null || resp === 'Infinity' ? '-' : numberFormat(resp))
//                 }
//             },
//             {
//                 field: 'salesPrice',
//                 headerName: t('divestment.salesPrice'),
//                 minWidth: 125,
//                 flex: 1,
//                 align: 'center',
//                 headerAlign: 'center',
//                 valueGetter: (params) => {
//                     const resp = numberFormat(params?.row?.salesPrice);
//                     return (resp === 'NaN' ? '-' : resp)
//                 }
//             },
//             {
//                 field: 'capitalGain',
//                 headerName: t('positions.capitalGain'),
//                 minWidth: 100,
//                 flex: 1,
//                 align: 'center',
//                 headerAlign: 'center',
//                 valueGetter: ({ row }) => {
//                     const sharesAmount = row.divestmentParticipation
//                     const newCapital = sharesAmount * row.salesPrice
//                     const resp = (newCapital - row.participationValuation * row.divestmentParticipation).toFixed(2)
//                     return (isNaN(resp) ? '-' : numberFormat(resp))
//                 }
//             },
//             {
//                 field: 'tacc',
//                 headerName: t('divestment.tacc'),
//                 minWidth: 140,
//                 flex: 1,
//                 align: 'center',
//                 headerAlign: 'center',
//                 renderCell: ({ row }) => {
//                     const divestmentDate = new Date(row.divestmentDate)
//                     const investmentDate = new Date(row.investmentDate)
//                     const diffDates = (divestmentDate.getTime() - investmentDate.getTime()) / 86400000
//                     const exponent = (1 / (diffDates / 365))
//                     const diffAmount = row.salesPrice / row.participationValuation
//                     const result = (((diffAmount ** exponent) - 1) * 100).toFixed(2)
//                     return (<Typography color='primary' variant='body2'>{result}%</Typography>)
//                 }
//             },
//         ]
//     )
// }

// export const columnDivestmentClubDetail = (t) => {
//     return (
//         [
//             {
//                 field: 'investmentDate',
//                 headerName: t('divestment.investmentDate'),
//                 minWidth: 140,
//                 flex: 1,
//                 align: 'center',
//                 headerAlign: 'center',
//                 renderCell: (params) => <Typography color='primary' variant='body2'> {toSpanishDate(params.row.investmentDate)}</Typography>
//             },
//             {
//                 field: 'whoInvests',
//                 headerName: t('divestment.whoInvests'),
//                 minWidth: 120,
//                 flex: 1,
//                 align: 'center',
//                 headerAlign: 'center',
//             },
//             {
//                 field: 'investmentType',
//                 headerName: t('positions.investmentType'),
//                 minWidth: 180,
//                 flex: 1,
//                 align: 'center',
//                 headerAlign: 'center'
//             },
//             {
//                 field: 'divestmentDate',
//                 headerName: t('divestment.divestmentDate'),
//                 minWidth: 150,
//                 flex: 1,
//                 align: 'center',
//                 headerAlign: 'center',
//                 renderCell: (params) => <Typography color='primary' variant='body2'>{toSpanishDate(params.row.divestmentDate)}</Typography>
//             },
//         ]
//     )
// }

export const columnClubDetail = (t) => {
  return [
    {
      field: "startup",
      headerName: t("divestment.startup"),
      minWidth: 145,
      flex: 1,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "divestmentDate",
      headerName: t("divestment.divestmentDate"),
      minWidth: 145,
      flex: 1,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => (
        <Typography color="primary" variant="body2">
          {toSpanishDate(params.row.divestmentDate)}
        </Typography>
      ),
    },
    {
      field: "roundNumber",
      headerName: t("positions.roundNumber"),
      minWidth: 70,
      flex: 1,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "amount",
      headerName: t("positions.amount"),
      minWidth: 90,
      flex: 1,
      align: "center",
      headerAlign: "center",
      valueGetter: ({ row }) =>
        numberFormat(
          (row.divestmentParticipation * row.participationValuation).toFixed(2)
        ),
    },
    {
      field: "participationValuation",
      headerName: t("positions.participationValuation"),
      minWidth: 140,
      flex: 1,
      align: "center",
      headerAlign: "center",
      valueGetter: ({ row }) => {
        const resp = row.participationValuation;
        return resp === null ? "-" : numberFormat(resp.toFixed(2));
      },
    },
    {
      field: "shares",
      headerName: t("positions.shares"),
      minWidth: 120,
      flex: 1,
      align: "center",
      headerAlign: "center",
      valueGetter: ({ row }) => {
        return participationsFormat(row.divestmentParticipation.toFixed(2));
      },
    },
    {
      field: "newAmount",
      headerName: t("positions.newAmount"),
      minWidth: 140,
      flex: 1,
      align: "center",
      headerAlign: "center",
      valueGetter: ({ row }) => numberFormat(row.salesPrice.toFixed(2)),
    },
    {
      field: "tir",
      headerName: t("positions.tir"),
      minWidth: 100,
      flex: 1,
      align: "center",
      headerAlign: "center",
      valueGetter: ({ row }) => {
        const amount = row.divestmentParticipation * row.participationValuation;
        const newCapital = row.divestmentParticipation * row.salesPrice;
        const capitalGain =
          newCapital - row.divestmentParticipation * row.participationValuation;

        const LN = Math.log((amount + capitalGain) / amount);
        const diffDates =
          millisToDays(
            new Date(row.divestmentDate) - new Date(row.investmentDate)
          ) / 365;

        return participationsFormat((Math.exp(LN / diffDates) - 1) * 100) + "%";
      },
    },
    {
      field: "moic",
      headerName: t("positions.moic"),
      minWidth: 100,
      flex: 1,
      align: "center",
      headerAlign: "center",
      valueGetter: ({ row }) => {
        const amount = row.divestmentParticipation * row.participationValuation;
        const newCapital = row.divestmentParticipation * row.salesPrice;
        const capitalGain =
          newCapital - row.divestmentParticipation * row.participationValuation;

        return participationsFormat((capitalGain + amount) / amount) + "x";
      },
    },
    {
      field: "capitalGain",
      headerName: t("positions.capitalGain"),
      minWidth: 100,
      flex: 1,
      align: "center",
      headerAlign: "center",
      valueGetter: ({ row }) => {
        const newCapital = row.divestmentParticipation * row.salesPrice;
        const resp =
          newCapital - row.divestmentParticipation * row.participationValuation;
        return numberFormat(resp.toFixed(2));
      },
    },
    {
      field: "vehicle",
      headerName: t("positions.vehicle"),
      minWidth: 200,
      flex: 1,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "whoInvests",
      headerName: t("positions.whoInvests"),
      minWidth: 200,
      flex: 1,
      align: "center",
      headerAlign: "center",
    },
  ];
};

export const columnsByStartupDivestment = (t) => {
  return [
    {
      field: "startup",
      headerName: t("positions.startup"),
      minWidth: 170,
      flex: 1,
      align: "center",
      headerAlign: "center",
      valueGetter: ({ row }) => row.startup,
    },
    {
      field: "amount",
      headerName: t("positions.amount"),
      minWidth: 100,
      flex: 1,
      align: "center",
      headerAlign: "center",
      valueGetter: ({ row }) => {
        const amount = row.data
          .map(
            (invest) =>
              invest.divestmentParticipation * invest.participationValuation
          )
          .reduce((a, b) => a + b, 0);
        return numberFormat(amount.toFixed(2));
      },
    },
    {
      field: "tir",
      headerName: t("positions.tir"),
      minWidth: 100,
      flex: 1,
      align: "center",
      headerAlign: "center",
      valueGetter: ({ row }) => {
        const investments = row.data.map((inv) => {
          const newCapital = inv.divestmentParticipation * inv.salesPrice;
          const cashflow = inv?.divestmentParticipation * inv?.participationValuation;
          const capitalGain =
          newCapital - cashflow;
          
          return {
            cashflow,
            investmentDate: inv.investmentDate,
            capitalGain:
              capitalGain === -0 ? 0 : capitalGain,
            divestmentDate: inv.divestmentDate,
          };
        });

        const investmentsFinal = transformDivestments(investments);

        const financeInstance = new finance();
        try {
          const tir = financeInstance.XIRR(
            investmentsFinal.map((inv) => parseFloat(inv.cashflow.toFixed(2))),
            investmentsFinal.map((inv) => new Date(inv.investmentDate)),
            -0.9
          );

          return isNaN(tir) || tir === Infinity
            ? "-100,00%"
            : tir.toLocaleString("es-ES", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }) + "%";
        } catch (error) {
          console.error("Error al calcular la TIR:", error);
          return "-100,00%";
        }
      },
    },
    {
      field: "moic",
      headerName: t("positions.moic"),
      minWidth: 100,
      flex: 1,
      align: "center",
      headerAlign: "center",
      valueGetter: ({ row }) => {
        const amount = row.data
          .map(
            (invest) =>
              invest.divestmentParticipation * invest.participationValuation
          )
          .reduce((a, b) => a + b, 0);
        const res = row.data.map((invest) => {
          const newCapital = invest.divestmentParticipation * invest.salesPrice;
          const resp =
            newCapital -
            invest.divestmentParticipation * invest.participationValuation;
          return resp;
        });
        const capitalGain = res.reduce((a, b) => a + b, 0);

        return participationsFormat((capitalGain + amount) / amount) + "x";
      },
    },
    {
      field: "capitalGain",
      headerName: t("positions.capitalGain"),
      minWidth: 100,
      flex: 1,
      align: "center",
      headerAlign: "center",
      valueGetter: ({ row }) => {
        const res = row.data.map((invest) => {
          const newCapital = invest.divestmentParticipation * invest.salesPrice;
          const resp =
            newCapital -
            invest.divestmentParticipation * invest.participationValuation;
          return resp;
        });
        return numberFormat(res.reduce((a, b) => a + b, 0).toFixed(2));
      },
    },
  ];
};
